import { render } from "./comNoticeBar.vue?vue&type=template&id=559a5c7a"
import script from "./comNoticeBar.vue?vue&type=script&lang=js"
export * from "./comNoticeBar.vue?vue&type=script&lang=js"

import "./comNoticeBar.vue?vue&type=style&index=0&id=559a5c7a&lang=css"

import exportComponent from "D:\\00project\\55bowlinglive\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__